export default __webpack_public_path__ + "static/banner3-30c701022c9e6d5b91d972c89d4bff80.jpg";